<mat-card *ngIf="page_flag">
    <mat-tab-group mat-stretch-tabs="false">

        <mat-tab [ngClass]="{ 'tab-disabled': create_flag==true }" label="Generated NOC ">
            <br>

            <div *ngIf="list_flag">

                <br>
                <div class="d-flex justify-content-between mb-3">
                    <div class="filter d-flex" *ngIf="list_flag && eng_Dept_flag || clerk_flag">
                        <i class="fa fa-search search_icon" aria-hidden="true"></i>
                        <input class="input-filter" placeholder="Search by Name, Letter Number"
                            (keyup)="applyFilter($any($event.target).value)">
                    </div>
                    <div *ngIf="clerk_flag" class="filter_icon">

                    </div>
                    <div *ngIf="eng_Dept_flag" class="filter_icon1">

                    </div>
                    <div class="export_btn" *ngIf="clerk_flag">
                        <button class="btn_export" (click)="open_create()">+ Create NOC</button>
                    </div>
                    <button *ngIf="list_flag && eng_Dept_flag || clerk_flag" class="btn_create" (click)="export()">
                        Export
                    </button>

                    <!-- <div class="export_btn" *ngIf="list_flag && eng_Dept_flag || clerk_flag">
                        <button class="btn_export" (click)="export()" >Export</button>
                    </div>
                    <button *ngIf="clerk_flag" class="btn_create" (click)="open_create()">
                        Create
                    </button> -->
                </div>

                <!-- <div class="example-container" style="text-size-adjust: 2; "
                    *ngIf="list_flag && eng_Dept_flag || clerk_flag"> -->
                <div class="example-container" style=" overflow-y: auto;text-size-adjust: 2;"
                    *ngIf="list_flag && eng_Dept_flag || clerk_flag">
                    <div style="overflow-x: auto;">
                        <table mat-table [dataSource]="datasource" matSort>

                            <ng-container matColumnDef="si_no">
                                <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                                    SI.NO
                                </th>
                                <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                    {{element.new_index}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="applicant_name">
                                <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                                    Applicant Name
                                </th>
                                <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                    {{element.party_name}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="file_number">
                                <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                                    File Number
                                </th>
                                <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                    {{element.file_number}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="letter_number">
                                <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                                    LDA Letter Number
                                </th>
                                <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                    {{element.lda_letter_number}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                                    Status
                                </th>
                                <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                    {{ element.status !== undefined ? element.status : element.life_cycle_status }}
                                </td>
                            </ng-container>


                            <ng-container matColumnDef="action" style="width: 5%;">
                                <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                                    Action</th>
                                <!--Action-->
                                <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                    <button class="btn btn-primary"
                                        *ngIf="element.life_cycle_status  == 'GENERATED' && element.under_village == 'NO'"
                                        (click)="send_to_ctp(element)">SEND TO CTP</button>&nbsp;
                                    <button class="btn btn-primary"
                                        *ngIf="element.life_cycle_status  == 'GENERATED' && element.under_village == 'YES'"
                                        (click)="send_to_ctp(element)">Send To Cartographer</button>&nbsp;
                                    <!-- <button class="btn btn-primary" *ngIf="eng_Dept_flag==false"
                                    (click)="open_update(element)" >Update</button>&nbsp; -->
                                    <!-- <button class="btn btn-primary" *ngIf="eng_Dept_flag ==false"
                                    (click)="delete(element)">DELETE</button> -->
                                    <span *ngIf="house_flag && element.status != 'APPROVED'">
                                        <button class="btn btn-primary"
                                        *ngIf="(eng_Dept_flag && element.status != 'APPROVED'  ||  element.fdstatus == 'ASSINGED_DEPT') && (element.house_tax_status !== 'PENDING') "
                                        (click)="add_to_approval(element)">Add to Approval </button>&nbsp;
                                    </span>
                                    <span *ngIf="!house_flag ">
                                        <button class="btn btn-primary"
                                        *ngIf="eng_Dept_flag && element.status != 'APPROVED' && element.status != 'OBJECTION'"
                                        (click)="add_to_approval(element)">Add to Approval </button>&nbsp;
                                    </span>
                                    <button class="btn btn-danger"
                                       *ngIf="element.status != 'APPROVED' && element.status != 'OBJECTION' && !clerk_flag"
                                    (click)="reject(element,'OBJECTION')">Objection</button>
                                    <!-- <button class="btn btn-primary"
                                        *ngIf="(eng_Dept_flag && element.status != 'APPROVED'  ||  element.fdstatus == 'ASSINGED_DEPT') && (element.house_tax_status == 'PENDING') "
                                        (click)="add_to_approval(element)">Add to Approval </button>&nbsp; -->
                                    <!-- <button class="btn btn-danger" *ngIf="eng_Dept_flag ||element.life_cycle_status != 'REJECTED'|| element.life_cycle_status!='GENERATED'"
                                    (click)="reject(element)">REJECT</button> -->
                                    <button class="btn btn-danger"
                                    *ngIf="element.status != 'APPROVED' && element.status != 'OBJECTION' && !clerk_flag && AMC_reject_flag"
                                 (click)="reject(element,'REJECTED')">Reject</button>

                                    <button class="btn btn-primary" (click)="view(element)">View
                                        File</button>

                                    <button class="btn btn-success"
                                        *ngIf="element.life_cycle_status != 'GENERATED' && eng_Dept_flag ==false"
                                        (click)="viewstatus(element)">File
                                        Status </button>
                                    <button class="btn btn-success" *ngIf="eng_Dept_flag ==true"
                                        (click)="viewdepstatus(element)">File
                                        Status </button>

                                </td>

                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                            </tr>
                        </table>
                    </div>
                    <mat-paginator [pageSizeOptions]="[5,10, 20]" showFirstLastButtons></mat-paginator>

                </div>





            </div>

            <div *ngIf="create_flag && clerk_flag">

                <mat-horizontal-stepper [linear]="isLinear" #stepper1>
                    <mat-step [stepControl]="first" label="File Creation" completed="false">

                        <br>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> File Number : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="email" class="form-control" placeholder=" Enter File Number "
                                    [(ngModel)]="NocObj['file_number']" [disabled]="true">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> LDA Letter Number : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6">
                                <input type="email" class="form-control" placeholder=" Enter  LDA Letter Number "
                                    [(ngModel)]="NocObj['lda_letter_number']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Applicant Name : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="name" class="form-control" placeholder=" Enter  Applicant Name  "
                                    [(ngModel)]="NocObj['party_name']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Applicant Father's Name/Husband's Name: <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="name" class="form-control" placeholder=" Enter  Applicant Father's Name/Husband's Name  "
                                    [(ngModel)]="NocObj['father_name']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Applicant Mobile Number : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">

                                <input class="form-control" placeholder=" Enter  Applicant Mobile Number "
                                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                    (input)="validateMobile($event)" type="number" maxlength="10"
                                    [(ngModel)]="NocObj['party_mobile']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Applicant Email ID : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="email" #ngInput class="form-control"
                                    placeholder=" Enter  Applicant Gmail ID " [(ngModel)]="NocObj['party_email']"
                                    (ngModelChange)="checkEmail(ngInput.value)">

                                <ng-container *ngIf="spanAvi==false; else elseTemplate" style="color: red">
                                    <span style="color: red"> <i>Enter Valid Email</i> </span>
                                </ng-container>
                                <ng-template #elseTemplate style="color: green">
                                    <span style="color: green"> <i>Email Is Valid</i></span>
                                </ng-template>
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6>Applicant Address : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="text" class="form-control" placeholder=" Enter  Address "
                                    [(ngModel)]="NocObj['address']">
                            </div>
                        </div>
                        <br>
                        <br>
                        <div class="row">
                            <div class="col-12 text-center">
                                <button mat-button mat-raised-button type="button" class="btn btn-success"
                                    (click)=open_list()>Back</button>
                                &nbsp;&nbsp;
                                <button mat-button mat-raised-button type="button" class="btn btn-primary"
                                    matStepperNext>Next</button>
                            </div>
                        </div>
                        <br>
                    </mat-step>
                    <br>
                    <br>
                    <br>
                    <mat-step [stepControl]="second" label="Area Details">
                        <br>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> All Floors Building area(In Square meter) : <span style="color: red;">*</span>
                                </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="number" class="form-control" placeholder=" Enter All Floors Building area  "
                                    [(ngModel)]="NocObj['all_floor_area']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Total Area(In Square meter) : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="number" class="form-control" placeholder=" Enter Total Area  "
                                    [(ngModel)]="NocObj['total_area']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> As per the Presented building map (In Square meter): </h6>
                            </div>
                            <div class="col-6 text-left">
                                <!-- <input type="email" class="form-control" placeholder=" Enter Building Type  "
                                    [(ngModel)]="NocObj['total_area']"> -->
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Front Setback : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="number" class="form-control" placeholder=" Enter Front Setback  "
                                    [(ngModel)]="NocObj['front_setback']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Side Setback Left : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="number" class="form-control" placeholder=" Enter Side Setback Left  "
                                    [(ngModel)]="NocObj['left_set']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Side Setback Right : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="number" class="form-control" placeholder=" Enter Side Setback Right "
                                    [(ngModel)]="NocObj['right_set']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Rare Set Back : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="number" class="form-control" placeholder=" Enter Rare Set Back "
                                    [(ngModel)]="NocObj['back_setback']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <!-- <div class="col-2"></div> -->
                            <div class="col-4 text-left">
                                <h6> Subject : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="text" class="form-control" placeholder=" Enter  Subject  "
                                    [(ngModel)]="NocObj['subject']">
                            </div>
                            <!-- <div class="col-2"></div> -->
                        </div>
                        <br>
                        <div class="row">
                            <!-- <div class="col-2"></div> -->
                            <div class="col-4 text-left">
                                <h6> Khasra No. : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="text" class="form-control" placeholder=" Enter  Khasra No. "
                                    [(ngModel)]="NocObj['khasra_no']">
                            </div>
                            <!-- <div class="col-2"></div> -->
                        </div>
                        <br>
                        <div class="row">
                            <!-- <div class="col-2"></div> -->
                            <div class="col-4 text-left">
                                <h6> Plot No. : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="text" class="form-control" placeholder=" Enter  Plot no  "
                                    [(ngModel)]="NocObj['plot_no']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Building Type : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="text" class="form-control" placeholder=" Enter Building Type  "
                                    [(ngModel)]="NocObj['building_type']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Zone : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="text" class="form-control" placeholder=" Enter  Zone "
                                    [(ngModel)]="NocObj['zone']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Village : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="text" class="form-control" placeholder=" Enter  Village "
                                    [(ngModel)]="NocObj['village']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Tehsil : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <ng-select [items]="Mainservice2Service.codeValueTechObj['NOC02']" bindLabel="value"
                                    bindValue="code" [multiple]="false" placeholder="" [(ngModel)]="NocObj['tehsil']"
                                    [selectableGroup]="true" [selectableGroupAsModel]="false" [closeOnSelect]="true"
                                    name="field_name" placeholder="Select Tehsil">
                                </ng-select>
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Address(for area which NOC is required) : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="text" class="form-control" placeholder=" Enter Address(for area which NOC is required) "
                                    [(ngModel)]="NocObj['addr_noc']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6>Do the address comes under the *89 village list : <span style="color: red;">*</span>
                                </h6>
                            </div>
                            <div class="col-6 text-left">
                                <ng-select [items]="Mainservice2Service.codeValueTechObj['NOC03']" bindLabel="value"
                                    bindValue="code" [multiple]="false" placeholder=""
                                    [(ngModel)]="NocObj['under_village']" [selectableGroup]="true"
                                    [selectableGroupAsModel]="false" [closeOnSelect]="true" name="field_name"
                                    placeholder="Do address comes under the *89 village list">
                                </ng-select>
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <label for="">
                                    <h6> Upload File : <span style="color: red;">*</span> </h6>
                                </label>
                                <p>
                                    JPEG, PNG, PDF, multiple files supported
                                </p>
                            </div>
                            <div class="col-6 text-left">
                                <input #uploaddocument type="file" multiple="true"
                                    accept="application/pdf,image/png,image/jpeg" class="upload-box form-control"
                                    style="border-color: black" (change)="uploaddoc($event)">
                            </div>
                            <!-- <div class="col-2"></div> -->
                        </div>
                        <br>
                        <br>
                        <div class="row">
                            <div class="col-12 text-center">
                                <button mat-button mat-raised-button class="btn btn-success"
                                    matStepperPrevious>Back</button>
                                &nbsp;&nbsp;
                                <button mat-button mat-raised-button class="btn btn-primary"
                                    matStepperNext>Next</button>
                            </div>
                        </div>

                    </mat-step>
                    <mat-step [stepControl]="third" label="Note Sheet">

                        <br>
                        <app-editor></app-editor>


                        <br>
                        <div class="row">
                            <div class="col-12 text-center">
                                <!-- <button mat-button mat-raised-button class="btn btn-danger" (click)=open_list()>Cancel</button> &nbsp;&nbsp; -->
                                <button mat-button mat-raised-button class="btn btn-success"
                                    matStepperPrevious>Back</button> &nbsp;&nbsp;
                                <!--Back-->
                                <button mat-button mat-raised-button class="btn btn-primary"
                                    matStepperNext>Next</button>
                                <!--Next-->


                            </div>
                        </div>



                    </mat-step>
                    <br>
                    <br>
                    <br>
                    <mat-step [stepControl]="fourth" label="Add Supportive Documents">
                        <br>
                        <br>
                        <div class="row">
                            <div class="col-5">
                                <hr class="hrline">
                            </div>
                            <div class="col-2 text-center">
                                <h6 id="h" style="color: brown; min-height: 20px;">
                                    Add Supportive Document :
                                </h6>
                            </div>
                            <div class="col-5">
                                <hr class="hrline">
                            </div>

                        </div>
                        <br>

                        <div class="row">
                            <!-- <div class="col-2">

                                </div> -->
                            <div class="col-4 text-left">
                                <label for="">
                                    <h6 id="h"> Upload File : </h6>
                                </label>
                                <p>
                                    JPEG, PNG, PDF, multiple files supported
                                </p>
                                <!-- <h6 id="h">
                                    Upload File :
                                </h6> -->
                            </div>

                            <div class="col-6 text-left">
                                <input #uploadsupprotivedocument type="file" multiple="true"
                                    accept="application/pdf,image/png,image/jpeg" class="upload-box form-control"
                                    style="border-color: black" (change)="addsupprotivedoc($event)">
                            </div>
                            <!-- <div class="col-1"></div> -->
                        </div>


                        <br>
                        <div class="row">
                            <div class="col-12 text-center">
                                <!-- <button mat-button mat-raised-button class="btn btn-danger" (click)=open_list()>Cancel</button> &nbsp;&nbsp; -->
                                <button mat-button mat-raised-button class="btn btn-success"
                                    matStepperPrevious>Back</button> &nbsp;&nbsp;
                                <!--Back-->
                                <button mat-button mat-raised-button class="btn btn-primary"
                                    (click)="submit()">Submit</button>
                                <!--Next-->


                            </div>
                        </div>



                    </mat-step>
                    <br>
                    <br>
                    <br>



                </mat-horizontal-stepper>



            </div>

            <div *ngIf="list_flag && ctp_flag">


                <!-- <br> -->

                <!-- 
                <div class="row" *ngIf="ctp_flag">
                    <div class="col-11 text-right">


                        <button style="margin: 5px;" (click)="open_create()" class="btn btn-success">Create
                            NOC</button>
                    </div>


                </div> -->


                <!-- <div class="row">
                    <div class="col-12 text-left">
                        <mat-form-field style="margin-left: 2%">
                            <input matInput (keyup)="applyFilter($any($event.target).value)"
                                placeholder="Filter">
                        </mat-form-field>
                    </div>
                </div> -->

                <!-- 
                <mat-form-field style="margin-left: 2%">
                    <input matInput (keyup)="applyFilter1($any($event.target).value)" placeholder="Filter">
                </mat-form-field> -->

                <div class="d-flex justify-content-between mb-3">
                    <div class="filter d-flex">
                        <i class="fa fa-search search_icon" aria-hidden="true"></i>
                        <input class="input-filter" placeholder="Search by Name, Letter Number"
                            (keyup)="applyFilter1($any($event.target).value)">
                    </div>
                    <div *ngIf="ctp_flag" class="filter_icon">

                    </div>

                    <div class="export_btn">
                        <button class="btn_export" style="background-color: #26344F;"
                            (click)="export1()">Export</button>
                    </div>

                </div>

                <div class=" example-container " style=" overflow-y: auto;text-size-adjust: 2;">
                    <table mat-table [dataSource]="datasource1" matSort #sortCol1="matSort">

                        <ng-container matColumnDef="si_no">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>S.NO.

                            </th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                <!-- {{this.mainService.accInfo['account_short_name']}} -->
                                {{element['new_index']}}
                            </td>
                        </ng-container>
                        <!-- 
                        <ng-container matColumnDef="document_type">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header> Document
                                Type

                            </th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{ element['doc_type']}} </td>
                        </ng-container> -->


                        <ng-container matColumnDef="file_number">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header> File No

                            </th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{ element.doc_local_no}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="file_desc">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>File Description

                            </th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.doc_desc}}
                            </td>
                        </ng-container>
                        <!-- <ng-container matColumnDef="role">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Role

                            </th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.role_cd}}
                            </td>
                        </ng-container> -->

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Status

                            </th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{ element.status}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Action

                            </th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                
                                <button class="btn btn-primary"
                                *ngIf="(element.status != 'APPROVED' && element.status != 'REJECTED') || element.final_approved === true"

                                    (click)="add_to_approval(element)">Send To Department </button>&nbsp;

                                <!-- <button class="btn btn-danger"
                                    *ngIf="element.status != 'APPROVED' && element.status != 'REJECTED'"
                                    (click)="reject(element)">REJECT</button> -->
                                    <button class="btn btn-danger"
                                    *ngIf="element.status != 'APPROVED' && element.status != 'REJECTED'"
                                    (click)="reject(element,'OBJECTION')">Objection</button>
                                <button class="btn btn-success" (click)="viewstatus(element)">File
                                    Status </button>

                                <button class="btn btn-primary" (click)="view(element)">View
                                    File</button>

                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns1;">
                        </tr>
                    </table>

                    <mat-paginator #paginator1 [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
                </div>





            </div>
            <div *ngIf="show_ctp_flag">
                <mat-horizontal-stepper [linear]="isLinear" #stepper1>
                    <mat-step [stepControl]="first" label="File Creation" completed="false">
                        <div class="row">
                            <div class="col-12">
                                <div class="div_header mt-3">
                                    <h6 class="text_sty">File Details</h6>
                                    <hr>
                                    <div class="inner_div mt-1">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <p>Applicant Name :</p>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                {{show_Data_obj['file_details']['party_name']}}</div>
                                        </div>
                                        <div class="row ">
                                            <div class="col-md-6">
                                                <p>Applicant Mobile Number :</p>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                {{show_Data_obj['file_details']['party_mobile']}}</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <p>LDA Letter Number :</p>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                {{show_Data_obj['file_details']['lda_letter_number']}}</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <p>Building Type :</p>
                                            </div>
                                            <div class="col-6 text-right">
                                                {{show_Data_obj['file_details']['building_type']}}</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <p>File Number :</p>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                {{show_Data_obj['file_details']['file_number']}}</div>
                                        </div>

                                        <div class="row" *ngIf="house_flag">
                                            <div class="col-md-6">
                                                <p>is house tax paid ? :</p>
                                            </div>
                                            <div class="col-md-6">
                                                <ng-select [items]="decision_box" [(ngModel)]="show_Data_obj['house_tax_paid']"
                                                    bindLabel="code" bindValue="code" placeholder="Select an item"
                                                    >
                                                </ng-select>
                                            </div>
                                        </div>
                                        <div class="row mt-2" *ngIf="house_flag && show_Data_obj['house_tax_paid'] == 'NO' ">
                                            <div class="col-md-6">
                                                <p>Enter House Tax :</p>
                                            </div>
                                            <div class="col-md-6">
                                                <input class="form-control" placeholder="Enter House Tax" [(ngModel)]="show_Data_obj['house_tax']">
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="row mt-2">
                            <div class="col-12 text-center">
                                <button mat-button mat-raised-button class="btn btn-success"
                                    (click)=open_list()>Back</button> &nbsp;&nbsp;
                                <!--Back-->
                                <button mat-button mat-raised-button class="btn btn-primary"
                                     (click)="check_houesetax(stepper1)">Next</button>
                                    
                            </div>
                        </div>





                    </mat-step>

                    <mat-step [stepControl]="second" label="Note Sheet">

                        <br>
                        <div class="row">
                            <div class="col-12 text-right addmore" (click)="addmorenotesheet()">
                                <span style=" color: rgb(184, 47, 47); 
                        font-weight: 600;">
                                    +
                                </span> Add More
                            </div>
                        </div>

                        <div class="div_header mt-4">
                            <div class="borderr" *ngFor="let item of show_Data_obj['file_notesheet']; let i = index">
                                <h6 class="text_sty">{{i+1}}.Notsheet</h6>
                                <!-- <div class="row" *ngFor="let item2 of item.supp_doc; let j = index">
                            <div class="col-12">
                                <h6 class="supp_doc" (click)="view_correspondence(item2.supp_doc_name)">{{j+1}}.{{item2.supp_doc_name}}</h6>
                            </div>
                         </div> -->
                                <hr>
                                <div class="inner_div mt-3">
                                    <div [class.hindi_text]="item['lang']=='Hindi'" [innerHTML]="item['description']">
                                    </div>

                                    <!-- <div class="page font-weight-bold">{{i+1}}</div> -->
                                    <!-- <div class="corresondence" style="cursor: pointer;" (click)="viewCorr(item.notesheet_id,item.notesheet_no)">View Correspondence</div> -->

                                </div>
                                <div style="color: red;font-size: bold;text-align: right;">
                                    ({{UserObj[item['user_id']]}})
                                </div>

                                <br>
                            </div>
                            <br>
                            <div *ngIf="current_noc_data" class="inner_div mt-3">
                                <h6 class="text_sty"> Added Notsheet</h6>
                                <hr>

                                <!-- <div  *ngFor="let item of show_Data_obj; let i = index"
                                style="border: 2px solid black;"> -->
                                <div [class.hindi_text]="current_noc_data['lang']=='Hindi'"
                                    [innerHTML]="current_noc_data['description']"></div>
                                <!-- </div> -->
                            </div>
                        </div>
                        <br>
                        <!-- <div *ngIf="current_noc_data"  style="border: 2px dotted black;"> -->
                        <!-- <div *ngIf="current_noc_data"  class="borderr">

                                <div  *ngFor="let item of show_Data_obj; let i = index"
                                style="border: 2px solid black;">
                                <div [class.hindi_text]="current_noc_data['lang']=='Hindi'"
                                    [innerHTML]="current_noc_data['description']"></div>
                               
                            </div>
                            <br>
                        </div> -->

                        <div class="row">
                            <div class="col-12 text-center">
                                <button mat-button mat-raised-button class="btn btn-success"
                                    matStepperPrevious>Back</button> &nbsp;&nbsp;
                                <!--Back-->
                                <button mat-button mat-raised-button class="btn btn-primary"
                                    matStepperNext>Next</button>
                            </div>
                        </div>

                    </mat-step>

                    <mat-step [stepControl]="third" label="Documents">
                        <br>

                        <div class="row">

                            <div class="col-12 text-right addmore" (click)="uploadmoredoc()">
                                <span style=" color: rgb(184, 47, 47); 
                             font-weight: 600;">
                                    +
                                </span> Add More
                            </div>
                        </div>
                        <br>
                        <div class="div div_header">
                            <h6 class="text_sty">Supporting Document</h6>
                            <hr>
                            <div class="row " *ngFor="let item of show_Data_obj.file_supp_doc; let i = index">
                                <div class="col-12 text_styy"
                                    (click)="view_correspondence(item.supp_doc_name,item.file_id)">{{i+1}}
                                    . {{item.supp_doc_name}}</div>
                                <!-- <div class="col-5">{{item.notesheet_id}}</div>
                           <div class="col-6"></div> -->
                            </div>
                            <!-- <div class="row " *ngFor="let item of NocObj['supportive_doc']; let j = index">
                                <div class="col-12 text_styy" (click)="view_correspondence(item.supp_doc_name,item.file_id)">{{j+1}}
                                    . {{item.supp_doc_name}}</div>
                             
                            </div> -->
                        </div>





                        <br>
                        <div class="row" *ngIf="!house_flag || show_Data_obj['house_tax_paid'] == 'YES'">
                            <div class="col-12 text-center">
                                <!-- <button mat-button mat-raised-button class="btn btn-danger" (click)=open_list()>Cancel</button> &nbsp;&nbsp; -->
                                <button mat-button mat-raised-button class="btn btn-success"
                                    matStepperPrevious>Back</button> &nbsp;&nbsp;
                                <!--Back-->
                                <button mat-button mat-raised-button class="btn btn-primary"
                                    *ngIf="eng_Dept_flag==false && ctp_flag ==true"
                                    (click)="submtctpdata()">Submit</button>
                                <button mat-button mat-raised-button class="btn btn-primary" *ngIf="eng_Dept_flag"
                                    (click)="submitjedata()">Submit</button>
                                <!--Next-->


                            </div>
                        </div>
                        <div class="row" *ngIf="house_flag && show_Data_obj['house_tax_paid'] == 'NO'">
                            <div class="col-12 text-center">
                               
                                <button mat-button mat-raised-button class="btn btn-success"
                                    matStepperPrevious>Back</button> &nbsp;&nbsp;
                            
                                <button mat-button mat-raised-button class="btn btn-primary" 
                                  (click)="insert_housetax()" >Forword To {{show_Data_obj['file_details']['party_name']}} for House Tax</button>
                              


                            </div>
                        </div>
                    </mat-step>




                </mat-horizontal-stepper>
            </div>

        </mat-tab>
        <mat-tab [ngClass]="{ 'tab-disabled': create_flag==true }" label="Objected">
            <br>
            <div *ngIf="list_flag">



                <div class="d-flex justify-content-between mb-3">
                    <div class="filter d-flex" *ngIf="list_flag && eng_Dept_flag || clerk_flag">
                        <i class="fa fa-search search_icon" aria-hidden="true"></i>
                        <input class="input-filter" placeholder="Search by Name, Letter Number"
                            (keyup)="applyFilter11($any($event.target).value)">
                    </div>

                    <div class="export_btn" *ngIf="list_flag && eng_Dept_flag || clerk_flag">
                        <button class="btn_export" (click)="export11()">Export</button>
                    </div>

                </div>

                <div class="example-container" style="text-size-adjust: 2;"
                    *ngIf="list_flag && eng_Dept_flag || clerk_flag">
                    <table mat-table [dataSource]="datasource11" matSort>

                        <ng-container matColumnDef="si_no">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                                SI.NO
                            </th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.new_index}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="applicant_name">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                                Applicant Name
                            </th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.party_name}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="file_number">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                                File Number
                            </th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.file_number}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="letter_number">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                                LDA Letter Number
                            </th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.lda_letter_number}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                                Status
                            </th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.life_cycle_status}}
                            </td>
                        </ng-container>


                        <ng-container matColumnDef="action" style="width: 5%;">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                                Action</th>
                            <!--Action-->
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                <button class="btn btn-primary" *ngIf="element.life_cycle_status  == 'GENERATED'"
                                    (click)="send_to_ctp(element)">SEND TO CTP</button>&nbsp;

                                <!-- <button class="btn btn-primary" *ngIf="eng_Dept_flag==false"
                                (click)="open_update(element)" >Update</button>&nbsp; -->
                                <!-- <button class="btn btn-primary" *ngIf="eng_Dept_flag ==false"
                                (click)="delete(element)">DELETE</button> -->
                                <!-- <button class="btn btn-primary"
                                    *ngIf="eng_Dept_flag || element.life_cycle_status == 'ASSINGED_DEPT'"
                                    (click)="add_to_approval(element)">Add To Approval </button>&nbsp; -->
                                <!-- <button class="btn btn-danger" *ngIf="eng_Dept_flag ||element.life_cycle_status != 'REJECTED'|| element.life_cycle_status!='GENERATED'"
                                (click)="reject(element)">REJECT</button> -->
                                <button class="btn btn-primary" (click)="update(element)" *ngIf="clerk_flag && element.life_cycle_status == 'OBJECTION'">Update
                                    File</button>
                                
                                <button class="btn btn-primary" (click)="view(element)">View
                                    File</button>

                                <button class="btn btn-success"
                                    *ngIf="element.life_cycle_status != 'GENERATED' && eng_Dept_flag ==false"
                                    (click)="viewstatus(element)">File
                                    Status </button>
                                <button class="btn btn-success" *ngIf="eng_Dept_flag ==true"
                                    (click)="viewdepstatus(element)">File
                                    Status </button>

                            </td>

                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                        </tr>
                    </table>
                    <mat-paginator [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>

                </div>





            </div>

            <div *ngIf="list_flag && ctp_flag">


                <br>



                <div class="d-flex justify-content-between mb-3">
                    <div class="filter d-flex">
                        <i class="fa fa-search search_icon" aria-hidden="true"></i>
                        <input class="input-filter" placeholder="Search by Name, Letter Number"
                            (keyup)="applyFilter12($any($event.target).value)">
                    </div>

                    <div class="export_btn">
                        <button class="btn_export" (click)="export12()">Export</button>
                    </div>

                </div>

                <div class=" example-container">
                    <table mat-table [dataSource]="datasource12" matSort #sortCol1="matSort">

                        <ng-container matColumnDef="si_no">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>S.NO.

                            </th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                <!-- {{this.mainService.accInfo['account_short_name']}} -->
                                {{element['new_index']}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="document_type">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header> Document
                                Type

                            </th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{ element['doc_type']}} </td>
                        </ng-container>


                        <ng-container matColumnDef="file_number">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header> File No

                            </th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{ element.doc_local_no}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="file_desc">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>File Description

                            </th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.doc_desc}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="role">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Role

                            </th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.role_cd}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Status

                            </th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{ element.status}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Action

                            </th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                <!-- <button class="btn btn-primary"
                                    *ngIf="element.status != 'APPROVED' && element.status != 'REJECTED'"
                                    (click)="add_to_approval(element)">Add To Approval </button>&nbsp; -->

                                <!-- <button class="btn btn-danger"
                                    *ngIf="element.status != 'APPROVED' && element.status != 'REJECTED'"
                                    (click)="reject(element,'OBJECTION')">REJECT</button> -->

                                <button class="btn btn-success" (click)="viewstatus(element)">File
                                    Status </button>

                                <button class="btn btn-primary" (click)="view(element)">View
                                    File</button>

                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns1;">
                        </tr>
                    </table>

                    <mat-paginator #paginator1 [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
                </div>





            </div>
             
            <div *ngIf="update_objection && clerk_flag">

                <mat-horizontal-stepper [linear]="isLinear" #stepper1>
                    <mat-step [stepControl]="first" label="File Creation" completed="false">

                        <br>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> File Number : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="email" class="form-control" placeholder=" Enter File Number "
                                    [(ngModel)]="NocObj['file_number']" [disabled]="true">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> LDA Letter Number : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6">
                                <input type="email" class="form-control" placeholder=" Enter  LDA Letter Number "
                                    [(ngModel)]="NocObj['lda_letter_number']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Applicant Name : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="name" class="form-control" placeholder=" Enter  Applicant Name  "
                                    [(ngModel)]="NocObj['party_name']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Applicant Mobile Number : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">

                                <input class="form-control" placeholder=" Enter  Applicant Mobile Number "
                                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                    (input)="validateMobile($event)" type="number" maxlength="10"
                                    [(ngModel)]="NocObj['party_mobile']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Applicant Email ID : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="email" #ngInput class="form-control"
                                    placeholder=" Enter  Applicant Gmail ID " [(ngModel)]="NocObj['party_email']"
                                    (ngModelChange)="checkEmail(ngInput.value)">

                                <ng-container *ngIf="spanAvi==false; else elseTemplate" style="color: red">
                                    <span style="color: red"> <i>Enter Valid Email</i> </span>
                                </ng-container>
                                <ng-template #elseTemplate style="color: green">
                                    <span style="color: green"> <i>Email Is Valid</i></span>
                                </ng-template>
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6>Applicant Address : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="text" class="form-control" placeholder=" Enter  Address "
                                    [(ngModel)]="NocObj['address']">
                            </div>
                        </div>
                        <br>
                        <br>
                        <div class="row">
                            <div class="col-12 text-center">
                                <button mat-button mat-raised-button type="button" class="btn btn-success"
                                    (click)=open_objection_list()>Back</button>
                                &nbsp;&nbsp;
                                <button mat-button mat-raised-button type="button" class="btn btn-primary"
                                    matStepperNext>Next</button>
                            </div>
                        </div>
                        <br>
                    </mat-step>
                    <br>
                    <br>
                    <br>
                    <mat-step [stepControl]="second" label="Area Details">
                        <br>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> All Floors Building area(In Square meter) : <span style="color: red;">*</span>
                                </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="number" class="form-control" placeholder=" Enter All Floors Building area  "
                                    [(ngModel)]="NocObj['all_floor_area']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Total Area(In Square meter) : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="number" class="form-control" placeholder=" Enter Total Area  "
                                    [(ngModel)]="NocObj['total_area']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> As per the Presented building map (In Square meter): </h6>
                            </div>
                            <div class="col-6 text-left">
                                <!-- <input type="email" class="form-control" placeholder=" Enter Building Type  "
                                    [(ngModel)]="NocObj['total_area']"> -->
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Front Setback : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="number" class="form-control" placeholder=" Enter Front Setback  "
                                    [(ngModel)]="NocObj['front_setback']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Side Setback Left : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="number" class="form-control" placeholder=" Enter Side Setback Left  "
                                    [(ngModel)]="NocObj['left_set']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Side Setback Right : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="number" class="form-control" placeholder=" Enter Side Setback Right "
                                    [(ngModel)]="NocObj['right_set']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Rare Set Back : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="number" class="form-control" placeholder=" Enter Rare Set Back "
                                    [(ngModel)]="NocObj['back_setback']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <!-- <div class="col-2"></div> -->
                            <div class="col-4 text-left">
                                <h6> Subject : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="text" class="form-control" placeholder=" Enter  Subject  "
                                    [(ngModel)]="NocObj['subject']">
                            </div>
                            <!-- <div class="col-2"></div> -->
                        </div>
                        <br>
                        <div class="row">
                            <!-- <div class="col-2"></div> -->
                            <div class="col-4 text-left">
                                <h6> Khasra No. : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="text" class="form-control" placeholder=" Enter  Khasra No. "
                                    [(ngModel)]="NocObj['khasra_no']">
                            </div>
                            <!-- <div class="col-2"></div> -->
                        </div>
                        <br>
                        <div class="row">
                            <!-- <div class="col-2"></div> -->
                            <div class="col-4 text-left">
                                <h6> Plot no : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="text" class="form-control" placeholder=" Enter  Plot no  "
                                    [(ngModel)]="NocObj['plot_no']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Building Type : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="text" class="form-control" placeholder=" Enter Building Type  "
                                    [(ngModel)]="NocObj['building_type']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Zone : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="text" class="form-control" placeholder=" Enter  Zone "
                                    [(ngModel)]="NocObj['zone']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Village : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="text" class="form-control" placeholder=" Enter  Village "
                                    [(ngModel)]="NocObj['village']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Tehsil : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <ng-select [items]="Mainservice2Service.codeValueTechObj['NOC02']" bindLabel="value"
                                    bindValue="code" [multiple]="false" placeholder="" [(ngModel)]="NocObj['tehsil']"
                                    [selectableGroup]="true" [selectableGroupAsModel]="false" [closeOnSelect]="true"
                                    name="field_name" placeholder="Select Tehsil">
                                </ng-select>
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6> Address(for area which NOC is required) : <span style="color: red;">*</span> </h6>
                            </div>
                            <div class="col-6 text-left">
                                <input type="text" class="form-control" placeholder=" Enter  Village "
                                    [(ngModel)]="NocObj['addr_noc']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <h6>Do the address comes under the *89 village list : <span style="color: red;">*</span>
                                </h6>
                            </div>
                            <div class="col-6 text-left">
                                <ng-select [items]="Mainservice2Service.codeValueTechObj['NOC03']" bindLabel="value"
                                    bindValue="code" [multiple]="false" placeholder=""
                                    [(ngModel)]="NocObj['under_village']" [selectableGroup]="true"
                                    [selectableGroupAsModel]="false" [closeOnSelect]="true" name="field_name"
                                    placeholder="Do address comes under the *89 village list">
                                </ng-select>
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-left">
                                <label for="">
                                    <h6> Upload File : <span style="color: red;">*</span> </h6>
                                </label>
                                <p>
                                    JPEG, PNG, PDF, multiple files supported
                                </p>
                            </div>
                            <div class="col-6 text-left">
                                <input #uploaddocument type="file" multiple="true"
                                    accept="application/pdf,image/png,image/jpeg" class="upload-box form-control"
                                    style="border-color: black" (change)="uploaddoc($event)">
                            </div>
                            <!-- <div class="col-2"></div> -->
                        </div>
                        <br>
                        <br>
                        <div class="row">
                            <div class="col-12 text-center">
                                <button mat-button mat-raised-button class="btn btn-success"
                                    matStepperPrevious>Back</button>
                                &nbsp;&nbsp;
                                <button mat-button mat-raised-button class="btn btn-primary"
                                    matStepperNext>Next</button>
                            </div>
                        </div>

                    </mat-step>
                    <mat-step [stepControl]="third" label="Note Sheet">

                        <br>
                        <app-editor></app-editor>


                        <br>
                        <div class="row">
                            <div class="col-12 text-center">
                                <!-- <button mat-button mat-raised-button class="btn btn-danger" (click)=open_list()>Cancel</button> &nbsp;&nbsp; -->
                                <button mat-button mat-raised-button class="btn btn-success"
                                    matStepperPrevious>Back</button> &nbsp;&nbsp;
                                <!--Back-->
                                <button mat-button mat-raised-button class="btn btn-primary"
                                    matStepperNext>Next</button>
                                <!--Next-->


                            </div>
                        </div>



                    </mat-step>
                    <br>
                    <br>
                    <br>
                    <mat-step [stepControl]="fourth" label="Add Supportive Documents">
                        <br>
                        <br>
                        <div class="row">
                            <div class="col-5">
                                <hr class="hrline">
                            </div>
                            <div class="col-2 text-center">
                                <h6 id="h" style="color: brown; min-height: 20px;">
                                    Add Supportive Document :
                                </h6>
                            </div>
                            <div class="col-5">
                                <hr class="hrline">
                            </div>

                        </div>
                        <br>

                        <div class="row">
                            <!-- <div class="col-2">

                                </div> -->
                            <div class="col-4 text-left">
                                <label for="">
                                    <h6 id="h"> Upload File : </h6>
                                </label>
                                <p>
                                    JPEG, PNG, PDF, multiple files supported
                                </p>
                                <!-- <h6 id="h">
                                    Upload File :
                                </h6> -->
                            </div>

                            <div class="col-6 text-left">
                                <input #uploadsupprotivedocument type="file" multiple="true"
                                    accept="application/pdf,image/png,image/jpeg" class="upload-box form-control"
                                    style="border-color: black" (change)="addsupprotivedoc($event)">
                            </div>
                            <!-- <div class="col-1"></div> -->
                        </div>


                        <br>
                        <div class="row">
                            <div class="col-12 text-center">
                                <!-- <button mat-button mat-raised-button class="btn btn-danger" (click)=open_list()>Cancel</button> &nbsp;&nbsp; -->
                                <button mat-button mat-raised-button class="btn btn-success"
                                    matStepperPrevious>Back</button> &nbsp;&nbsp;
                                <!--Back-->
                                <button mat-button mat-raised-button class="btn btn-primary"
                                    (click)="submit_objection_file()">Submit</button>
                                <!--Next-->


                            </div>
                        </div>



                    </mat-step>
                    <br>
                    <br>
                    <br>



                </mat-horizontal-stepper>



            </div>







        </mat-tab>
    </mat-tab-group>

    <ngx-spinner type="ball-atom">
        <p style="color: white"> Loading... </p>
    </ngx-spinner>
</mat-card>






















<!-- /////////work flow start//////// -->
<!-- WORKFLOW MODEL -->
<div class="modal" id="myModal3">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title">Approval</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <div class="row"
                    *ngIf="ApprovalUserService.vendorflag==false && ApprovalUserService.approvalflag==false">
                    <div class="col-4 text-right">
                        <h6>Select Forwarded To :</h6>
                    </div>
                    <div class="col-4">
                        <ng-select [items]="ApprovalUserService.workuser" bindLabel="desc" bindValue="user_id_appr"
                            [multiple]="false" placeholder="Select User" [(ngModel)]="forwarded_user_id"
                            [selectableGroup]="true" [selectableGroupAsModel]="false" [closeOnSelect]="true"
                            name="work_order_id">
                        </ng-select>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-4 text-right">
                        <h6>Remark :</h6>
                    </div>
                    <div class="col-4">
                        <textarea style="width: 100%; height: 80px;" id="re" name="re" [(ngModel)]="appr_remark"
                            placeholder="Enter Your Remark" class="form-control"></textarea>
                    </div>
                </div>
                <br>

                <div>
                    <table class="table table-bordered"
                        style="width: 90%; margin-left: 5%;overflow-x:scroll;scroll-margin-block: 1; ">
                        <thead>
                            <tr style="background-color:  white;">
                                <th style="width: 20%;">S No.</th>
                                <th style="width: 20%;">Decription</th>
                                <th style="width: 60%;">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let ln of undertakings;let i = index">
                                <td>{{i+1}}</td>
                                <td>{{ln['desc']}}</td>
                                <td style="width: 60%;">
                                    <input type="checkbox" [(ngModel)]="ln['check']" style="color: green;">

                                </td>
                            </tr>

                        </tbody>

                    </table>
                </div>
                <br>
                <div class="row" style="border: black;">
                    <div class="col-4 text-right">
                        <input type="checkbox" [(ngModel)]="message_flag" id="vehicle1" name="vehicle1" value="Bike">
                    </div>
                    <div class="col-4">
                        Notify Them
                    </div>
                </div>
                <br>
                <div class="row"
                    *ngIf="ApprovalUserService.vendorflag==false && ApprovalUserService.approvalflag==false">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" data-dismiss="modal" (click)="Approvedapproval()">Submit
                        </button>
                    </div>
                </div>
                <div class="row"
                    *ngIf="ApprovalUserService.vendorflag==false && ApprovalUserService.approvalflag==true">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" data-dismiss="modal" (click)="lastlevelappr()">Submit
                        </button>
                    </div>
                </div>
                <br>

                <div *ngIf="ApprovalUserService.vendorflag==true" class="row">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" data-dismiss="modal" (click)="Approvedapproval()">Forward To
                            Vendor</button>
                    </div>
                </div>
                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                </div>

            </div>
        </div>
    </div>
</div>


<!-- /////////work flow start//////// -->
<!-- WORKFLOW MODEL -->
<div class="modal" id="notesheetmodal">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title">Remark</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <br>
                <div class="row">
                    <div class="col-4 text-right">
                        <h6> Add Remark <span style="color: red;">*</span> : </h6>
                    </div>
                    <div class="col-4"></div>
                    <div class="col-4"></div>

                </div>
                <!-- New Code for Notesheet -->
                <div class="notesheet" *ngIf="added_notesheet">

                    <app-editor></app-editor>


                </div>


                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" (click)="addctpnotesheet()">Submit</button>
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                </div>

            </div>
        </div>
    </div>
</div>


<div class="modal" id="uploadmoredocmodal">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title">Upload Document </h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <br>
                <div class="row">
                    <!-- <div class="col-2">

                        </div> -->
                    <div class="col-4 text-left">
                        <h6 id="h">
                            Upload File :
                        </h6>
                    </div>

                    <div class="col-6 text-left">
                        <input #uploadsupprotivedocument type="file" multiple="true" accept="application/pdf"
                            class="upload-box form-control" style="border-color: black"
                            (change)="addsupprotivedoc($event)">
                    </div>
                    <!-- <div class="col-1"></div> -->
                </div>
                <br>
                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Submit</button>
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                </div>

            </div>
        </div>
    </div>
</div>


<!-- <div class="modal" id="department">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            
            <div class="modal-header">
                <h4 class="modal-title">Department</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <br>
                <div class="row">
                    <table id="tbl1">

                        <tr>

                            <th>
                                S.NO.
                            </th>
                            <th>
                                Department
                            </th>
                             <th>Role</th>
                            <th>
                                user
                            </th>

                        </tr>
                        
                        <tr *ngFor="let obj of eng_Dept let i = index" >
                            <td>{{i+1}}</td>
                            <td  style="text-decoration: underline;">
                                {{obj['leaf_value']}}</td>
                            <td>
                                <button (click)="getList(obj['leaf_cd'])" class="btn btn-primary">Get Role</button>
                            </td>
                            <td>
                                <ng-select [items]="user_list" [(ngModel)]="eng_Dept[i]['user_name']" bindLabel="name"
                                    bindValue="user_id" placeholder="Select an item" [disabled]="user_list.length > 0">
                                </ng-select>
                            </td>

                        </tr>
              
                         

                        <tr *ngFor="let obj of prop_Dept let i = index" >
                            <td>{{i+2}}</td>
                            <td style="text-decoration: underline;">
                                {{obj['leaf_value']}}</td>
                                <td>
                                    <button (click)="getList(prop_Dept[i]['leaf_cd'])" class="btn btn-primary">Get Role</button>
                                </td>
                            <td>
                                <ng-select [items]="user_list1" [(ngModel)]="prop_Dept[i]['user_name']" bindLabel="name"
                                    bindValue="user_id" placeholder="Select an item" >
                                </ng-select>
                            </td>
                        </tr>
                    
                        
                        
                        <tr *ngFor="let obj of tax_Dept let i = index" >
                            <td>{{i+3}}</td>
                            <td style="text-decoration: underline;">
                                {{obj['leaf_value']}}</td>
                                <td>
                                    <button (click)="getList(tax_Dept[i]['leaf_cd'])" class="btn btn-primary">Get Role</button>
                                </td>
                            <td>
                                <ng-select [items]="user_list2" [(ngModel)]="tax_Dept[i]['user_name']" bindLabel="name"
                                    bindValue="user_id" placeholder="Select an item" [disabled]="user_list2.length > 0">
                                </ng-select>
                            </td>
                        </tr>
                

                    </table>

                </div>
                 <div class="row">
                    <div class="co-1"></div>
                 </div>
               













                
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" *ngIf="ctp_flag ==true && eng_Dept_flag==false"
                        (click)="submitctpdata()">Submit</button>

                    <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                </div>

            </div>
        </div>
    </div>
</div> -->

<div class="modal fade" id="department" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel">
    <div class="modal-dialog modal-lg " role="document" style="max-width: 65%;">
        <div class="modal-content">
            <div class="modal-header" style="background-color: #26344F;">
                <h4 class="modal-title" style="font: bold;color: white; ">Department :
                </h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="close()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" style="background-color: white;">
                <div class="row ">
                    <div class="col-2"></div>
                    <div class="col-2 text-center"><b>S.NO.</b></div>
                    <div class="col-2 text-center"> <b>Department</b></div>
                    <div class="col-2 text-center"><b>Role</b></div>
                    <div class="col-2 text-center"><b>user</b></div>
                    <div class="col-2"></div>
                </div>
                <br>
                <div class="row" *ngIf="property_approved_flag">
                    <div class="row" *ngFor="let obj of eng_Dept let i = index">
                        <div class="col-2"></div>
                        <div class="col-2 text-center">{{i+1}}</div>
                        <div class="col-2 text-center"> {{obj['leaf_value']}}</div>
                        <div class="col-2 text-center">
                            <button (click)="getList(obj['leaf_cd'])" class="btn btn-primary">Get Role</button>
                        </div>
                        <div class="col-2 text-center">
                            <ng-select [items]="user_list" [(ngModel)]="eng_Dept[i]['user_name']" bindLabel="name"
                                bindValue="user_id" placeholder="Select an item" [disabled]="user_list.length == 0">
                            </ng-select>
                        </div>
                        <div class="col-2"></div>
                    </div>
                </div>
                <br>
                <div class="div" *ngIf="!property_approved_flag">
                    <div class="row" *ngFor="let obj of prop_Dept let i = index">
                        <div class="col-2"></div>
                        <div class="col-2 text-center">{{i+1}}</div>
                        <div class="col-2 text-center">{{obj['leaf_value']}}</div>
                        <div class="col-2 text-center ">
                            <button (click)="getList(prop_Dept[i]['leaf_cd'])" class="btn btn-primary">Get Role</button>
                        </div>
                        <div class="col-2 text-center">
                            <ng-select [items]="user_list1" [(ngModel)]="prop_Dept[i]['user_name']" bindLabel="name"
                                bindValue="user_id" placeholder="Select an item"  >
                            </ng-select>
                        </div>
                        <div class="col-2"></div>
                    </div>
                </div>
                <br>

                <div class="div" *ngIf="property_approved_flag">
                    <div class="row" *ngFor="let obj of tax_Dept let i = index">
                        <div class="col-2"></div>
                        <div class="col-2 text-center">{{i+1}}</div>
                        <div class="col-2 text-center"> {{obj['leaf_value']}}</div>
                        <div class="col-2 text-center">
                            <button (click)="getList(tax_Dept[i]['leaf_cd'])" class="btn btn-primary">Get Role</button>
                        </div>
                        <div class="col-2 text-center"><ng-select [items]="user_list2"
                                [(ngModel)]="tax_Dept[i]['user_name']" bindLabel="name" bindValue="user_id"
                                placeholder="Select an item" [disabled]="user_list2.length == 0">
                            </ng-select></div>
                        <div class="col-2"></div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" *ngIf="ctp_flag ==true && eng_Dept_flag==false"
                    (click)="submitctpdata()">Submit</button>

                <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>























<!-- WORKFLOW MODEL -->
<div class="modal" id="rejected">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title">Objected</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">



                <!-- New Code for Notesheet -->
                <div class="notesheet">
                    <div class="row">

                        <div class="col-3">
                            <h6> Add Remark <span style="color: red;">*</span> </h6>
                        </div>
                        <!-- <div *ngIf="isRejectButtonActive"> -->
                        <div *ngIf="rejected_notesheet">

                            <app-editor></app-editor>
                        </div>
                        <!-- <div class="col-3"><label for="Language"> Select Language :</label>

                        </div>
                        <div class="col-3">
                            <ng-select [items]="lang_list" (change)="onChangeLang()" [multiple]="false"
                                placeholder="Select Language" [(ngModel)]="selectedLang" [selectableGroup]="true"
                                [selectableGroupAsModel]="false" [closeOnSelect]="true">
                            </ng-select>

                        </div> -->
                        <div class="col-3">
                            <!-- <label for="Language" *ngIf="hindi_text_flag"> Select Font :</label> -->
                        </div>
                        <div class="col-3">
                            <!-- <ng-select [items]="font_list" (change)="onChangeFont()" [multiple]="false"
                                placeholder="Select Font" [(ngModel)]="selectedFont" [selectableGroup]="true"
                                [selectableGroupAsModel]="false" [closeOnSelect]="true" *ngIf="hindi_text_flag">
                            </ng-select> -->
                        </div>

                    </div>

                    <!-- <div id="text-input" contenteditable="true" (blur)="getAllcontent($event)" #textContent2
                        [class.hindi_text]="hindi_text_flag" style="font-size: 2.2rem">

                    </div> -->
                </div>

                <br>
                <div class="row" style="border: black;">
                    <div class="col-4 text-right">
                        <input type="checkbox" [(ngModel)]="message_flag" id="vehicle1" name="vehicle1" value="Bike">
                    </div>
                    <div class="col-4">
                        Notify Them
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" data-dismiss="modal" (click)="finalreject()">Submit
                        </button>
                    </div>
                </div>
                <br>


                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                </div>

            </div>
        </div>
    </div>
</div>
<div class="modal" id="objected">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header" style="background-color: #26344F;color: white;">
                <h4 class="modal-title" >Objected</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">



                <!-- New Code for Notesheet -->
                <div class="notesheet">
                    <div class="row">

                        <div class="col-3">
                            <h6> Add Remark <span style="color: red;">*</span> </h6>
                        </div>
                        <!-- <div *ngIf="isRejectButtonActive"> -->
                        <div>

                            <app-editor></app-editor>
                        </div>
                        <!-- <div class="col-3"><label for="Language"> Select Language :</label>

                        </div>
                        <div class="col-3">
                            <ng-select [items]="lang_list" (change)="onChangeLang()" [multiple]="false"
                                placeholder="Select Language" [(ngModel)]="selectedLang" [selectableGroup]="true"
                                [selectableGroupAsModel]="false" [closeOnSelect]="true">
                            </ng-select>

                        </div> -->
                        <div class="col-3">
                            <!-- <label for="Language" *ngIf="hindi_text_flag"> Select Font :</label> -->
                        </div>
                        <div class="col-3">
                            <!-- <ng-select [items]="font_list" (change)="onChangeFont()" [multiple]="false"
                                placeholder="Select Font" [(ngModel)]="selectedFont" [selectableGroup]="true"
                                [selectableGroupAsModel]="false" [closeOnSelect]="true" *ngIf="hindi_text_flag">
                            </ng-select> -->
                        </div>

                    </div>

                    <!-- <div id="text-input" contenteditable="true" (blur)="getAllcontent($event)" #textContent2
                        [class.hindi_text]="hindi_text_flag" style="font-size: 2.2rem">

                    </div> -->
                </div>

                <br>
                <div class="row" style="border: black;">
                    <div class="col-4 text-right">
                        <input type="checkbox" [(ngModel)]="message_flag" id="vehicle1" name="vehicle1" value="Bike">
                    </div>
                    <div class="col-4">
                        Notify Them
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" data-dismiss="modal" (click)="rejectnewrowapproval()">Submit
                        </button>
                    </div>
                </div>
                <br>


                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="modal" id="myModal">
    <div class="modal-dialog modal-xl" style="max-width:95%;">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header" style="background-color: #26344F;font: bold;color: white; ">
                <h4 class="modal-title">File Status : </h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body " >
                <div class="row" style="margin-left: 30%;" *ngIf="role=='CRK' || 'CTP'">

                    <a *ngFor="let ob of statusArr?.['CTP']; let i = index">
                        <div class="step completed" *ngIf="ob.status == 'APPROVED'">
                            <div class="v-stepper">
                                <div class="circle"></div>
                                <div class="barblue" style="color: blue; margin-left: 40%;"
                                    *ngIf="i < statusArr['CTP'].length - 1"></div>
                            </div>
                            <div class="content">
                                {{ UserObj[ob['user_id']] }}-{{ ob['role_cd'] }}-{{ ob['status'] }}
                                <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                    }}</span>
                            </div>
                        </div>
                        <div class="step" *ngIf="ob.status == 'REJECTED'">
                            <div class="v-stepper">
                                <div class="circles"></div>
                            </div>
                            <div class="content">
                                {{ UserObj[ob['user_id']] }}-{{ ob['role_cd'] }}-{{ ob['status'] }}
                                <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                    }}</span>
                            </div>
                        </div>
                        <div class="step" *ngIf="ob.status == 'OBJECTION'">
                            <div class="v-stepper">
                                <div class="circles"></div>
                            </div>
                            <div class="content">
                                {{ UserObj[ob['user_id']] }}-{{ ob['role_cd'] }}-{{ ob['status'] }}
                                <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                    }}</span>&nbsp;&nbsp;&nbsp;<button class="btn btn-primary" (click)="view_remark(ob)">View Remark</button>
                            </div>
                        </div>
                        <div class="step" *ngIf="ob.status == 'PENDING'">
                            <div class="v-stepper">
                                <div class="circle"></div>
                                <div class="bar" style="color: black; margin-left: 40%;"
                                    *ngIf="i < statusArr['CTP'].length - 1"></div>
                            </div>
                            <div class="content">
                                {{ UserObj[ob['user_id']] }}-{{ ob['role_cd'] }}-{{ ob['status'] }}
                                <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                    }}</span>
                            </div>
                        </div>
                        <div class="step" *ngIf="ob.status == 'FORWARDED'">
                            <div class="v-stepper">
                                <div class="circle"></div>
                                <div class="bar" style="color: black; margin-left: 40%;"
                                    *ngIf="i < statusArr['CTP'].length - 1"></div>
                            </div>
                            <div class="content">
                                {{ UserObj[ob['user_id']] }}-{{ ob['role_cd'] }}-{{ ob['status'] }}
                                <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                    }}</span>
                            </div>
                        </div>
                    </a>
                </div>

                <!-- <div class="arrow-container">
                    <div class="upper-vertical-line"></div>
                    <div class="arrow-horizontal"></div>
                    <div class="arrow-holder">
                      <div class="arrow arrow-left"></div>
                      <div class="arrow arrow-center"></div>
                      <div class="arrow arrow-right"></div>
                    </div>
                  </div> -->
                <br>
                <div class="row" *ngIf="role !='CRK'" style="max-height: 5000px;">
                    <div class="col-4" *ngIf="departmnt_data?.['ENGINEERING']?.length > 0">
                        <h5 style="font-weight:bold;color:rgb(78, 16, 114)">Engineering Department</h5><br>
                        <a *ngFor="let ob of departmnt_data['ENGINEERING']; let i = index">
                            <div class="step completed" *ngIf="ob.status == 'APPROVED'">
                                <div class="v-stepper">
                                    <div class="circle"></div>
                                    <div class="barblue" style="color: blue; margin-left: 40%;"
                                        *ngIf="i < departmnt_data['ENGINEERING'].length - 1"></div>
                                </div>
                                <div class="content">
                                    {{ UserObj[ob['user_id']] }}-{{ ob['role_cd'] }}-{{ ob['status'] }}
                                    <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                        }}</span>
                                </div>
                            </div>
                            <div class="step" *ngIf="ob.status == 'REJECTED'">
                                <div class="v-stepper">
                                    <div class="circles"></div>
                                </div>
                                <div class="content">
                                    {{ UserObj[ob['user_id']] }}-{{ ob['role_cd'] }}-{{ ob['status'] }}
                                    <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                        }}</span>
                                </div>
                            </div>
                            <div class="step" *ngIf="ob.status == 'PENDING'">
                                <div class="v-stepper">
                                    <div class="circle"></div>
                                    <div class="bar" style="color: black; margin-left: 40%;"
                                        *ngIf="i < departmnt_data['ENGINEERING'].length - 1"></div>
                                </div>
                                <div class="content">
                                    {{ UserObj[ob['user_id']] }}-{{ ob['role_cd'] }}-{{ ob['status'] }}
                                    <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                        }}</span>
                                </div>
                            </div>
                            <div class="step" *ngIf="ob.status == 'FORWARDED'">
                                <div class="v-stepper">
                                    <div class="circle"></div>
                                    <div class="bar" style="color: black; margin-left: 40%;"
                                        *ngIf="i < statusArr['CTP'].length - 1"></div>
                                </div>
                                <div class="content">
                                    {{ UserObj[ob['user_id']] }}-{{ ob['role_cd'] }}-{{ ob['status'] }}
                                    <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                        }}</span>
                                </div>
                            </div>
                            <div class="step" *ngIf="ob.status == 'OBJECTION'">
                                <div class="v-stepper">
                                    <div class="circles"></div>
                                </div>
                                <div class="content">
                                    {{ UserObj[ob['user_id']] }}-{{ ob['role_cd'] }}-{{ ob['status'] }}
                                    <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                        }}</span>&nbsp;&nbsp;&nbsp;<button class="btn btn-primary" (click)="view_remark(ob)">View Remark</button>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-4" *ngIf="departmnt_data?.['TAX']?.length > 0">
                        <h5 style="font-weight:bold;color:rgb(78, 16, 114)">TAX Department</h5><br>
                        <a *ngFor="let ob of departmnt_data['TAX']; let i = index">
                            <div class="step completed" *ngIf="ob.status == 'APPROVED'">
                                <div class="v-stepper">
                                    <div class="circle"></div>
                                    <div class="barblue" style="color: blue; margin-left: 40%;"
                                        *ngIf="i < departmnt_data['TAX'].length - 1"></div>
                                </div>
                                <div class="content">
                                    {{ UserObj[ob['user_id']] }}-{{ ob['role_cd'] }}-{{ ob['status'] }}
                                    <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                        }}</span>
                                </div>
                            </div>
                            <div class="step" *ngIf="ob.status == 'REJECTED'">
                                <div class="v-stepper">
                                    <div class="circles"></div>
                                </div>
                                <div class="content">
                                    {{ UserObj[ob['user_id']] }}-{{ ob['role_cd'] }}-{{ ob['status'] }}
                                    <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                        }}</span>
                                </div>
                            </div>
                            <div class="step" *ngIf="ob.status == 'PENDING'">
                                <div class="v-stepper">
                                    <div class="circle"></div>
                                    <div class="bar" style="color: black; margin-left: 40%;"
                                        *ngIf="i < departmnt_data['TAX'].length - 1"></div>
                                </div>
                                <div class="content">
                                    {{ UserObj[ob['user_id']] }}-{{ ob['role_cd'] }}-{{ ob['status'] }}
                                    <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                        }}</span>
                                </div>
                            </div>
                            <div class="step" *ngIf="ob.status == 'FORWARDED'">
                                <div class="v-stepper">
                                    <div class="circle"></div>
                                    <div class="bar" style="color: black; margin-left: 40%;"
                                        *ngIf="i < departmnt_data['TAX'].length - 1"></div>
                                </div>
                                <div class="content">
                                    {{ UserObj[ob['user_id']] }}-{{ ob['role_cd'] }}-{{ ob['status'] }}
                                    <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                        }}</span>
                                </div>
                            </div>
                            <div class="step completed" *ngIf="ob.status == 'PAID'">
                                <div class="v-stepper">
                                    <div class="circle"></div>
                                    <div class="barblue" style="color: black; margin-left: 40%;"
                                    *ngIf="i < departmnt_data['TAX'].length - 1"></div>
                                </div>
                                <div class="content">
                                    {{ ob['role_cd'] }}-{{ ob['status'] }}
                                    <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                        }}</span>
                                </div>
                            </div>
                            <div class="step" *ngIf="ob.status == 'OBJECTION'">
                                <div class="v-stepper">
                                    <div class="circles"></div>
                                </div>
                                <div class="content">
                                    {{ UserObj[ob['user_id']] }}-{{ ob['role_cd'] }}-{{ ob['status'] }}
                                    <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                        }}</span>&nbsp;&nbsp;&nbsp;<button class="btn btn-primary" (click)="view_remark(ob)">View Remark</button>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-4" *ngIf="departmnt_data?.['PROPERTY']?.length > 0">
                        <h5 style="font-weight:bold;color:rgb(78, 16, 114)">Property Department</h5><br>
                        <a *ngFor="let ob of departmnt_data['PROPERTY']; let i = index">
                            <div class="step completed" *ngIf="ob.status == 'APPROVED'">
                                <div class="v-stepper">
                                    <div class="circle"></div>
                                    <div class="barblue" style="color: blue; margin-left: 40%;"
                                        *ngIf="i < departmnt_data['PROPERTY'].length - 1"></div>
                                </div>
                                <div class="content">
                                    {{ UserObj[ob['user_id']] }}-{{ ob['role_cd'] }}-{{ ob['status'] }}
                                    <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                        }}</span>
                                </div>
                            </div>
                            <div class="step" *ngIf="ob.status == 'REJECTED'">
                                <div class="v-stepper">
                                    <div class="circles"></div>
                                </div>
                                <div class="content">
                                    {{ UserObj[ob['user_id']] }}-{{ ob['role_cd'] }}-{{ ob['status'] }}
                                    <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                        }}</span>
                                </div>
                            </div>
                            <div class="step" *ngIf="ob.status == 'PENDING'">
                                <div class="v-stepper">
                                    <div class="circle"></div>
                                    <div class="bar" style="color: black; margin-left: 40%;"
                                        *ngIf="i < departmnt_data['PROPERTY'].length - 1"></div>
                                </div>
                                <div class="content">
                                    {{ UserObj[ob['user_id']] }}-{{ ob['role_cd'] }}-{{ ob['status'] }}
                                    <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                        }}</span>
                                </div>
                            </div>
                            <div class="step" *ngIf="ob.status == 'FORWARDED'">
                                <div class="v-stepper">
                                    <div class="circle"></div>
                                    <div class="bar" style="color: black; margin-left: 40%;"
                                        *ngIf="i < statusArr['CTP'].length - 1"></div>
                                </div>
                                <div class="content">
                                    {{ UserObj[ob['user_id']] }}-{{ ob['role_cd'] }}-{{ ob['status'] }}
                                    <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                        }}</span>
                                </div>
                            </div>
                            <div class="step" *ngIf="ob.status == 'OBJECTION'">
                                <div class="v-stepper">
                                    <div class="circles"></div>
                                </div>
                                <div class="content">
                                    {{ UserObj[ob['user_id']] }}-{{ ob['role_cd'] }}-{{ ob['status'] }}
                                    <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                        }}</span>&nbsp;&nbsp;&nbsp;<button class="btn btn-primary" (click)="view_remark(ob)">View Remark</button>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>

                <div class="row" style="margin-left: 30%;" *ngIf="role !='CRK'">
                    <a *ngFor="let ob of statusArr?.['other']; let i = index">
                        <div class="step completed" *ngIf="ob.status == 'APPROVED'">
                            <div class="v-stepper">
                                <div class="circle"></div>
                                <div class="barblue" style="color: blue; margin-left: 40%;"
                                    *ngIf="i < statusArr['other'].length - 1"></div>
                            </div>
                            <div class="content">
                                {{ UserObj[ob['user_id']] }}-{{ ob['role_cd'] }}-{{ ob['status'] }}
                                <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                    }}</span>
                            </div>
                        </div>
                        <div class="step" *ngIf="ob.status == 'REJECTED'">
                            <div class="v-stepper">
                                <div class="circles"></div>
                            </div>
                            <div class="content">
                                {{ UserObj[ob['user_id']] }}-{{ ob['role_cd'] }}-{{ ob['status'] }}
                                <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                    }}</span>
                            </div>
                        </div>
                        <div class="step" *ngIf="ob.status == 'PENDING'">
                            <div class="v-stepper">
                                <div class="circle"></div>
                                <div class="bar" style="color: black; margin-left: 40%;"
                                    *ngIf="i < statusArr['other'].length - 1"></div>
                            </div>
                            <div class="content">
                                {{ UserObj[ob['user_id']] }}-{{ ob['role_cd'] }}-{{ ob['status'] }}
                                <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                    }}</span>
                            </div>
                        </div>
                    </a>
                </div>

                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="modal" id="departmentworkflow">
    <div class="modal-dialog modal-lg" style="max-width: 80%; height: 70%;" >
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title">Status</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body scrollable-modal-body">
                <div class="container" >
                    <!-- completed -->
                    <a *ngFor="let ob of alldata;let i=index">
                        <div class="step completed" *ngIf="ob.status=='APPROVED'">
                            <div class="v-stepper">
                                <div class="circle"></div>
                                <div class="barblue" style="color: blue;margin-left: 40%;" *ngIf="i <alldata.length-1">
                                </div>
                            </div>

                            <div class="content">
                                {{UserObj[ob['user_id']]}}-{{ob['role_cd']}}-{{ob['status']}}
                                <span style="color:red">{{ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'}}</span>
                            </div>
                        </div>
                        <div class="step" *ngIf="ob.status=='REJECTED'">
                            <div class="v-stepper">
                                <div class="circles"></div>

                            </div>

                            <div class="content">
                                {{UserObj[ob['user_id']]}}-{{ob['role_cd']}}-{{ob['status']}}
                                <span style="color:red">{{ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'}}</span>
                            </div>
                        </div>
                        <div class="step" *ngIf="ob.status=='OBJECTION'">
                            <div class="v-stepper">
                                <div class="circles"></div>

                            </div>

                            <div class="content">
                                {{UserObj[ob['user_id']]}}-{{ob['role_cd']}}-{{ob['status']}}
                                <span style="color:red">{{ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'}}</span>&nbsp;<button class="btn btn-primary" (click)="view_remark(ob)">View Remark</button>
                            </div>
                        </div>
                        <!-- active -->
                        <div class="step" *ngIf="ob.status=='PENDING'">
                            <div class="v-stepper">
                                <div class="circle"></div>
                                <div class="bar" style="color: black;margin-left: 40%;" *ngIf="i <alldata.length-1">
                                </div>
                            </div>

                            <div class="content">
                                {{UserObj[ob['user_id']]}}-{{ob['role_cd']}}-{{ob['status']}}
                                <span style="color:red">{{ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'}}</span>
                            </div>
                        </div>
                        <div class="step" *ngIf="ob.status=='FORWARDED'">
                            <div class="v-stepper">
                                <div class="circle"></div>
                                <div class="bar" style="color: black;margin-left: 40%;" *ngIf="i <alldata.length-1">
                                </div>
                            </div>

                            <div class="content">
                                {{UserObj[ob['user_id']]}}-{{ob['role_cd']}}-{{ob['status']}}
                                <span style="color:red">{{ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'}}</span>
                            </div>
                        </div>
                        <div class="step completed" *ngIf="ob.status == 'HOUSE_TAX_PAID'">
                            <div class="v-stepper">
                                <div class="circle"></div>
                                <div class="barblue" style="color: black; margin-left: 40%;"
                                *ngIf="i < departmnt_data['TAX'].length - 1"></div>
                            </div>
                            <div class="content">
                                {{ ob['role_cd'] }}-{{ ob['status'] }}
                                <span style="color: red">{{ ob['create_timestamp'] | date: 'dd/MM/yyyy h:mm:ss a'
                                    }}</span>
                            </div>
                        </div>
                    </a>


                </div>

                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="modal" id="remark">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title">Remark</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body scrollable-modal-body" *ngIf="remark_text">
                <div class="inner_div mt-3">
                <div class="notesheet_header font-weight-bold"  [innerHTML]="remark_text.header"><br>
                </div>
                <div class="body"  [innerHTML]="remark_text.body" ></div>
                <div class="footer"  [innerHTML]="remark_text.footer"></div>
                <!-- <div class="page font-weight-bold">{{i+1}}</div> -->
                <!-- <div class="corresondence" style="cursor: pointer;" (click)="viewCorr(item.notesheet_id,item.notesheet_no)">View Correspondence</div> -->
                <div style="color: red;font-size: bold;text-align: right;">
                    ({{remark_text['user_name']}}) 
                 </div>
                </div>
                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                </div>

            </div>
        </div>
    </div>
</div>









<ngx-spinner type="ball-atom">
    <p style="color: white"> Loading... </p>
</ngx-spinner>